import styled from "styled-components";
import { Form } from "formik";

export const FormElem = styled(Form)`
    flex-grow: 4;
    display: flex;
    flex-flow: column;
`;